import type { TranslationDict } from '../en';

const bn: TranslationDict = {
  // ─── Header ───
  'header.buy': 'কিনুন',
  'header.sell': 'বিক্রি করুন',

  // ─── SpendCard ───
  'spend.label': 'আপনি ব্যয় করছেন',
  'spend.placeholderFiat': '250',
  'spend.placeholderCrypto': '0.01',

  // ─── ReceiveCard ───
  'receive.label': 'আপনি পাচ্ছেন',

  // ─── PaymentCard ───
  'payment.label': 'পেমেন্ট পদ্ধতি',
  'payment.select': 'বেছে নিন',
  'provider.label': 'By',
  'provider.select': 'Select',
  'provider.unavailable': 'Unavailable',
  'provider.unavailablePayment': 'Payment method not supported',
  'provider.unavailableCountry': 'Region not supported',
  'provider.unavailableCurrency': 'Currency not supported',
  'provider.unavailableNetwork': 'Network not supported',
  'payment.noneAvailable': 'এই জোড়ার জন্য কোনো পেমেন্ট পদ্ধতি নেই',

  // ─── WalletCard ───
  'wallet.label': 'প্রাপক ওয়ালেট ঠিকানা',
  'wallet.placeholderBuy': 'আপনার প্রাপক ঠিকানা লিখুন',
  'wallet.placeholderSell': 'আপনার প্রেরক ঠিকানা লিখুন',
  'wallet.validating': 'ঠিকানা যাচাই হচ্ছে...',
  'wallet.invalid': 'একটি বৈধ ওয়ালেট ঠিকানা লিখুন',
  'wallet.invalidServer': 'অবৈধ ওয়ালেট ঠিকানা',

  // ─── CtaButton ───
  'cta.buy': '{crypto} কিনুন',
  'cta.sell': '{crypto} বিক্রি করুন',
  'cta.gettingPrice': 'সেরা মূল্য খোঁজা হচ্ছে...',
  'cta.processing': 'প্রক্রিয়া করা হচ্ছে...',

  // ─── Footer ───
  'footer.poweredBy': 'পরিচালিত ',
  'footer.brand': 'NowRamp',

  // ─── Rate Breakdown ───
  'rate.title': 'রেটের বিবরণ',
  'rate.close': 'বন্ধ করুন',
  'rate.updatesIn': 'রেট আপডেট হবে 00:{seconds} এ',
  'rate.noQuote': 'কোনো কোটেশন পাওয়া যায়নি',
  'rate.exchangeRate': 'বিনিময় হার',
  'rate.processingFee': 'প্রক্রিয়াকরণ ফি',
  'rate.networkFee': 'নেটওয়ার্ক ফি',
  'rate.provider': 'প্রদানকারী',

  // ─── Toast ───
  'toast.orderCreated': 'অর্ডার তৈরি হয়েছে',
  'toast.redirecting': 'চেকআউটে পুনঃনির্দেশিত হচ্ছে...',
  'toast.orderFailed': 'অর্ডার ব্যর্থ হয়েছে',
  'toast.couldNotCreate': 'অর্ডার তৈরি করা সম্ভব হয়নি',
  'toast.quoteError': 'কোটেশন ত্রুটি',
  'toast.noProviders': 'কোনো প্রদানকারী নেই',
  'toast.somethingWrong': 'কিছু একটা ভুল হয়েছে',

  // ─── Form errors ───
  'error.amountZero': 'পরিমাণ ০-এর বেশি হতে হবে',
  'error.minAmountFiat': 'সর্বনিম্ন পরিমাণ {min} {currency}',
  'error.minAmountCrypto': 'সর্বনিম্ন পরিমাণ {min} {currency}',
  'error.noProviders': 'এই সংমিশ্রণের জন্য কোনো প্রদানকারী পাওয়া যায়নি',
  'error.currencyUnavailableBuy': 'এই মুদ্রা ক্রয় অর্ডারের জন্য উপলব্ধ নয়',
  'error.currencyUnavailableSell': 'এই মুদ্রা বিক্রয় অর্ডারের জন্য উপলব্ধ নয়',

  // ─── Parity banner ───
  'parity.info': 'আপনার কাছ থেকে {receiveAmount} {crypto}-এর জন্য চার্জ করা হবে, বাকি {spendAmount} {fiat} পর্যন্ত আপনার {partner} অ্যাকাউন্টে জমা হবে',

  // ─── Redirect Screen ───
  'redirect.secureBadge': 'নিরাপদ পেমেন্ট',
  'redirect.title': 'পেমেন্ট চালিয়ে যান',
  'redirect.description': 'পেমেন্ট সম্পন্ন করতে আপনাকে {gateway}-এ পুনঃনির্দেশিত করা হবে।',
  'redirect.countdown': '{seconds} সেকেন্ডে পুনঃনির্দেশিত হচ্ছে...',
  'redirect.openTab': 'নতুন ট্যাবে ACH খুলুন',
  'redirect.cancel': 'বাতিল করুন',

  // ─── Checkout Step ───
  'checkout.noOrder': 'কোনো অর্ডার পাওয়া যায়নি',
  'checkout.goBack': 'ফিরে যান',
  'checkout.expired': 'চেকআউটের মেয়াদ শেষ',
  'checkout.expiredDesc': 'সেশনের মেয়াদ শেষ হয়ে গেছে। আবার চেষ্টা করুন।',
  'checkout.startOver': 'নতুন করে শুরু করুন',
  'checkout.cancel': 'বাতিল করুন',
  'checkout.loading': 'চেকআউট লোড হচ্ছে...',
  'checkout.iframeTitle': 'প্রদানকারী চেকআউট',
  'checkout.widgetTitle': 'পেমেন্ট চেকআউট',
  'checkout.unknownMethod': 'অজানা চেকআউট পদ্ধতি',

  // ─── Processing Step ───
  'processing.default': 'আপনার অর্ডার প্রক্রিয়া করা হচ্ছে...',
  'processing.pending': 'পেমেন্ট নিশ্চিতকরণের অপেক্ষায়...',
  'processing.active': 'আপনার লেনদেন প্রক্রিয়া করা হচ্ছে...',
  'processing.generic': 'প্রক্রিয়া করা হচ্ছে...',
  'processing.checkingStatus': 'অবস্থা যাচাই করা হচ্ছে...',
  'processing.orderId': 'অর্ডার আইডি',
  'processing.provider': 'প্রদানকারী',
  'processing.amount': 'পরিমাণ',
  'processing.receiving': 'গ্রহণ করা হচ্ছে',
  'processing.network': 'নেটওয়ার্ক',
  'processing.toAddress': 'প্রাপক ঠিকানা',
  'processing.usuallyMinutes': 'এটি সাধারণত কয়েক মিনিট সময় নেয়।',
  'processing.safeToClose': 'আপনি নিরাপদে এই পেজটি বন্ধ করতে পারেন — সম্পন্ন হলে আমরা আপনাকে ইমেইল করব।',

  // ─── Complete Step ───
  'complete.buyTitle': 'ক্রয় সম্পন্ন!',
  'complete.sellTitle': 'বিক্রয় সম্পন্ন!',
  'complete.buyDesc': 'আপনার {crypto} আপনার ওয়ালেটে পাঠানো হয়েছে।',
  'complete.sellDesc': 'আপনার {fiat} পেআউট প্রক্রিয়া করা হচ্ছে।',
  'complete.amountBuy': 'প্রাপ্ত পরিমাণ',
  'complete.amountSell': 'বিক্রিত পরিমাণ',
  'complete.paidBuy': 'পরিশোধিত পরিমাণ',
  'complete.paidSell': 'পেআউট পরিমাণ',
  'complete.network': 'নেটওয়ার্ক',
  'complete.wallet': 'ওয়ালেট',
  'complete.transaction': 'লেনদেন',
  'complete.provider': 'প্রদানকারী',
  'complete.orderId': 'অর্ডার আইডি',
  'complete.completed': 'সম্পন্ন',
  'complete.viewExplorer': 'এক্সপ্লোরারে দেখুন',
  'complete.done': 'হয়ে গেছে',

  // ─── Error Step ───
  'errorStep.failed': 'পেমেন্ট ব্যর্থ',
  'errorStep.cancelled': 'অর্ডার বাতিল',
  'errorStep.expired': 'অর্ডারের মেয়াদ শেষ',
  'errorStep.refunded': 'অর্ডার ফেরত দেওয়া হয়েছে',
  'errorStep.unknown': 'কিছু একটা ভুল হয়েছে',
  'errorStep.failedBuy': 'আপনার পেমেন্ট প্রক্রিয়া করা সম্ভব হয়নি। আবার চেষ্টা করুন বা অন্য একটি পেমেন্ট পদ্ধতি ব্যবহার করুন।',
  'errorStep.failedSell': 'আপনার বিক্রয় প্রক্রিয়া করা সম্ভব হয়নি। আবার চেষ্টা করুন।',
  'errorStep.cancelledBuy': 'আপনার অর্ডার বাতিল করা হয়েছে। কোনো পেমেন্ট প্রক্রিয়া করা হয়নি।',
  'errorStep.cancelledSell': 'আপনার বিক্রয় বাতিল করা হয়েছে। কোনো ক্রিপ্টো স্থানান্তর হয়নি।',
  'errorStep.expiredBuy': 'আপনার অর্ডারের মেয়াদ শেষ হয়ে গেছে। নতুন ক্রয় শুরু করুন।',
  'errorStep.expiredSell': 'আপনার অর্ডারের মেয়াদ শেষ হয়ে গেছে। নতুন বিক্রয় শুরু করুন।',
  'errorStep.refundedBuy': 'আপনার পেমেন্ট ফেরত দেওয়া হয়েছে। ৫-১০ কার্যদিবসের মধ্যে অর্থ আপনার অ্যাকাউন্টে দেখা যাবে।',
  'errorStep.refundedSell': 'আপনার ক্রিপ্টো ফেরত দেওয়া হয়েছে। শীঘ্রই অর্থ আপনার ওয়ালেটে দেখা যাবে।',
  'errorStep.genericDesc': 'একটি অপ্রত্যাশিত ত্রুটি ঘটেছে। আবার চেষ্টা করুন।',
  'errorStep.orderId': 'অর্ডার আইডি',
  'errorStep.tryAgain': 'আবার চেষ্টা করুন',
  'errorStep.startOver': 'নতুন করে শুরু করুন',
  'errorStep.return': 'ফিরে যান',
  'errorStep.needHelp': 'সাহায্য দরকার? যোগাযোগ করুন ',
  'errorStep.reference': 'রেফারেন্স: {orderId}',

  // ─── Confirm Step ───
  'confirm.buyTitle': 'ক্রয় নিশ্চিত করুন',
  'confirm.sellTitle': 'বিক্রয় নিশ্চিত করুন',
  'confirm.loading': 'লোড হচ্ছে...',
  'confirm.provider': 'প্রদানকারী',
  'confirm.youPay': 'আপনি পরিশোধ করছেন',
  'confirm.youSell': 'আপনি বিক্রি করছেন',
  'confirm.youReceive': 'আপনি পাচ্ছেন',
  'confirm.wallet': 'ওয়ালেট',
  'confirm.network': 'নেটওয়ার্ক',
  'confirm.refundAddress': 'ফেরত ঠিকানা',
  'confirm.parityNote': 'প্রদানকারীর চার্জ করা পরিমাণ ভিন্ন হতে পারে। বাকি {amount} {crypto} পর্যন্ত আপনার {partner} অ্যাকাউন্টে জমা হবে।',
  'confirm.processing': 'প্রক্রিয়া করা হচ্ছে...',
  'confirm.confirmPay': 'নিশ্চিত করুন এবং পরিশোধ করুন',
  'confirm.confirmSell': 'নিশ্চিত করুন এবং বিক্রি করুন',
  'confirm.payout': '{currency} পেআউট',

  // ─── Modals ───
  'modal.selectFiat': 'ফিয়াট মুদ্রা বেছে নিন',
  'modal.selectCrypto': 'ক্রিপ্টো মুদ্রা বেছে নিন',
  'modal.choosePayment': 'পেমেন্ট পদ্ধতি বেছে নিন',
  'modal.selectCountry': 'আপনার দেশ বেছে নিন',
  'modal.selectLanguage': 'Select language',
  'modal.popular': 'জনপ্রিয়',
  'modal.recommended': 'প্রস্তাবিত',
  'modal.noCurrencies': 'কোনো মুদ্রা পাওয়া যায়নি',
  'modal.noPaymentMethods': 'কোনো পেমেন্ট পদ্ধতি পাওয়া যায়নি',
  'modal.noCountries': 'কোনো দেশ পাওয়া যায়নি',
  'modal.noLanguages': 'No languages found',

  // ─── Settings ───
  'settings.location': 'অবস্থান',
  'settings.darkMode': 'ডার্ক মোড',
  'settings.privacy': 'গোপনীয়তা নীতি',
  'settings.terms': 'ব্যবহারের শর্তাবলি',
  'settings.language': 'ভাষা',

  // ─── Additional ───
  'modal.chooseRamp': 'Ramp বেছে নিন',
  'modal.bestPrice': 'সেরা মূল্য',
  'modal.noQuotes': 'এই অনুরোধের জন্য কোনো কোটেশন পাওয়া যায়নি',
  'modal.noProvidersFound': 'কোনো প্রদানকারী পাওয়া যায়নি',
  'payment.unavailableFor': '{currency}-এর জন্য কোনো পেমেন্ট পদ্ধতি নেই',
  'skeleton.poweredBy': 'NowRamp দ্বারা পরিচালিত',
  'error.createOrderFailed': 'অর্ডার তৈরি করতে ব্যর্থ হয়েছে',
  'errorStep.returnToMerchant': 'মার্চেন্টে ফিরে যান',
  'confirm.cryptoOnNetwork': '{crypto} {network}-এ',
  'payment.name.card': 'কার্ড',
  'payment.name.bankTransfer': 'ব্যাংক ট্রান্সফার',
  'payment.name.ach': 'ACH',
  'rate.updatesInLabel': 'Rate updates in',
  'rate.networkFeeIncl': 'Network fee incl.',
  'rate.rateTooltip': 'As the market is highly volatile, we can fix the exchange rate for no longer than 30 seconds.',
  'rate.networkFeeTooltip': 'Includes a fee charged by blockchain to execute the transaction.',
  'rate.feeIncluded': '{percentage}% incl.',
  'receive.fetchingRate': 'Fetching best rate...',
  'redirect.tabHelper': 'If the new tab has not opened, click the button above.',
};

export default bn;
